import Link from '../common/prefixName';

// @var String   production | test | development
var mode = '';

if (Link.isDev) {   // development 开发环境
    mode = 'development';
}
else if (Link.isDebug)
{
    mode = 'test';
}
else
{
    mode = 'prod';
}

export default {

    newShixun : {
        baseUrl : (function(){
            switch (mode)
            {
                case 'development' :
                    return '//h5.shixun365.com/shixun-mobile-2020/';
                case 'test' :
                    return '//h5.shixun365.com/shixun-mobile-2020/';
                case 'prod' :
                    return '//yj.shixun365.com/shixun-mobile-2020/';
            }
            return '';
        })()
    },

    zysj : {
        baseUrl : (function(){
            switch (mode)
            {
                case 'development' :
                    return '//h5.shixun365.com/zysj-mobile/';
                case 'test' :
                    return '//h5.shixun365.com/zysj-mobile/';
                case 'prod' :
                    return '//circle.shixun365.com/zysj-mobile/';
            }
            return '';
        })()
    },
};



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/data/externalApp.js
 **/